import axios from "../api/axios";

export async function uploadFile(file, folder, publicId) {
  const formData = new FormData();
  formData.append("folder", folder);
  formData.append("publicID", publicId);
  formData.append("file", file, file.name || "upload");

  const res = await axios.post("/upload", formData);
  return res.data; // { secure_url, public_id }
}

export async function deleteFile(publicId) {
  return axios.post("/upload/delete", { public_id: publicId });
}
